"use strict";

(function () {
  'use strict';

  function RelationshipService($http, $q, $uibModal) {
    var getList = function getList(type) {
      if (!type) {
        type = 0;
      }

      var deferred = $q.defer();
      $http.get('/connections/' + type).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    var checkSingleApproved = function checkSingleApproved(adminCustDataId) {
      var deferred = $q.defer();
      $http.get('/connections/partner/' + adminCustDataId).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        if (error.status === 404) {
          deferred.reject('no_manager');
        } else {
          deferred.reject('error');
        }
      });
      return deferred.promise;
    };

    var approve = function approve(adminCustDataId) {
      var deferred = $q.defer();
      $http.post('/connections/approve', {
        adminCustDataId: adminCustDataId
      }).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    var openApprovalModal = function openApprovalModal(_partner) {
      function ApprovalModal(partner, $uibModalInstance) {
        this.partner = partner;
        this.close = $uibModalInstance.close;
        this.dismiss = $uibModalInstance.dismiss;
      }

      ApprovalModal.$inject = ['partner', '$uibModalInstance'];
      return $uibModal.open({
        template: '<connection-modal partner="$ctrl.partner" close="$ctrl.close($event)" dismiss="$ctrl.dismiss($event)"/>',
        controllerAs: '$ctrl',
        animation: false,
        keyboard: false,
        backdrop: 'static',
        controller: ApprovalModal,
        size: 'md',
        resolve: {
          partner: function partner() {
            return angular.copy(_partner);
          }
        }
      }).result;
    };

    return {
      getList: getList,
      approve: approve,
      checkSingleApproved: checkSingleApproved,
      openApprovalModal: openApprovalModal
    };
  }

  RelationshipService.$inject = ['$http', '$q', '$uibModal'];
  angular.module('connections-service', []).factory('ConnectionsService', RelationshipService);
})();